import LicenseModel from "common/models/license/LicenseModel";
export default {

    /**
     * This gets all of the messaging info for licensing related things.
     * @private
     */
    _getMessagingInfo: function() {

        return $.ajax({
            url: context.path + "/webservices/rest/license/message",
            method: "GET"
        });

    },

    /**
     * This sets all of the messaging info for licensing related things.
     * @private
     */
    _setMessagingInfo: function(data) {
        return $.ajax({
            url: context.path + "/webservices/rest/license/message",
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(data)
        });
    },

    /**
     * Get the number of days before license expiration a warning will be sentt.
     * @returns promise
     */
    getDaysForWarning: function() {
        return this._getMessagingInfo().then(function(data) {
            return data.days;
        });
    },

    /**
     * Set the number days before license expiration a warning will be sent.
     *
     * This first gets all the properties, then change the single one needed.
     * This is done so that we don't overwrite changes done on other screens
     * to the other properties.
     *
     * @param days
     * @returns promise
     */
    setDaysForWarning: function(days) {
        var me = this;
        return this._getMessagingInfo().then(function(data) {
            data.days = days;
            return me._setMessagingInfo(data);
        });
    },

    /**
     * Get license reporting threshold and frequency.
     * @returns promise
     */
    getUsageReportOptions: function() {
        return this._getMessagingInfo().then(function(data) {
            return data;
        });
    },

    /**
     * Set license reporting threshold and frequency.
     *
     * @param threshold
     * @param frequency
     * @returns promise
     */
    setUsageReportThresholdAndFrequency: function(threshold, frequency) {
        var me = this;
        return this._getMessagingInfo().then(function(data) {
            data.days = data.days;
            data.threshold = threshold;
            data.emailFrequency = frequency;
            return me._setMessagingInfo(data);
        });
    },

    /**
     * Get all of the license properties.
     * @returns {*}
     */
    getLicense: function() {
        return $.ajax({
            url: context.path + "/webservices/rest/license/details",
            method: "GET"
        }).then(function(data) {
            return new LicenseModel(data);
        });
    },

    updateLicense: function(key) {
        return $.ajax({
            url: context.path + "/webservices/rest/license",
            method: "POST",
            contentType: "text/plain",
            data: key
        }).then(function(data) {
            return new LicenseModel(data);
        });
    },

    decodeLicense(key) {
        return $.ajax({
            url: context.path + "/webservices/rest/license/decode",
            method: "POST",
            contentType: "text/plain",
            data: key
        }).then(function(data) {
            return new LicenseModel(data);
        });
    },

    /**
     * Get license usage metrics.
     * @returns object
     */
    getLicenseUsageMetrics: function() {
        return $.ajax({
            url: context.path + "/webservices/rest/license/metrics/",
            type: "GET",
            dataType: "json",
            contentType: "application/json"
        });
    },

    /**
     * Revoke a batch of licenses.
     * @param userIds - array of user ids to revoke licenses for
     * @returns null
     */
    revokeLicenses(userIds) {
        return $.ajax({
            url: `${context.path}/webservices/rest/license/revoke/users`,
            type: "DELETE",
            contentType: "application/json",
            data: JSON.stringify(userIds)
        });
    },

    /**
     * Revokes all other licenses for the current user
     */
    revokeConcurrentLicenses: function() {
        return $.ajax({
            url: context.path + "/webservices/rest/license/concurrent/revoke",
            type: "POST",
            contentType: "application/json"
        });
    },

    /**
     * Keep the session alive
     */
    sessionKeepAlive: function() {
        return $.ajax({
            url: context.path + "/webservices/rest/license/keepalive",
            type: "POST",
            contentType: "application/json"
        });
    },

    /**
     * Get the status of the current session
     */
    sessionHealth: function() {
        return $.ajax({
            url: context.path + "/webservices/rest/license/sessionhealth",
            type: "GET",
            contentType: "application/json"
        });
    },

    getApiUsageThreshold() {
        return $.ajax({
            url: `${context.path}/webservices/rest/license/api/threshold`,
            type: "GET",
            contentType: "application/json"
        });
    },

    setApiUsageThreshold(enabled, threshold) {
        return $.ajax({
            url: `${context.path}/webservices/rest/license/api/threshold`,
            type: "POST",
            contentType: "application/json",
            data: kendo.stringify({enabled, threshold})
        });
    }
};
